import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import TimeClock from "@/pages/TimeClock";
export const Route = createFileRoute("/time-clock")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><TimeClock /></ProtectedRoute>) });
